<template>
    <div id="payment-wrap">
        <div class="row payment-type-row">
            <div class="col-md-3 text-right plabel">Payment Type:</div>
            <div class="col-md-9">
                <select class="form-control" ref="payment_type" v-model="model.payment_type">
                    <template v-if="layout != 'guest'">
                        <option value="po">PO</option>
                    </template>
                    <option value="credit-card">Credit Card</option>
                    <option value="wire-transfer">Wire Transfer / ACH</option>
                    <option value="check">Check</option>
                </select>
            </div>
        </div>

        <template v-if="model.payment_type == 'po'">
            <template v-if="cars && Object.keys(cars).length > 1">
                <div class="row mt-2">
                    <div class="col-md-9 offset-md-3">
                        <label class="d-flex align-items-center"><input type="checkbox" class="ml-1 mr-1" v-model="model.po_by_car"> <b>Purchase by Car</b></label>
                    </div>
                </div>
            </template>
            
            <template v-if="model.po_by_car">
                <template v-for="(car, key) in cars">
                    <div class="po-wrap" :ref="'po_wrap' + key" :key="key">
                        <div class="row input-wrap">
                            <div class="col-md-3 text-right plabel"><b>Car {{ car.car_id_number }}</b></div>
                        </div>
                        <div class="row input-wrap">
                            <div class="col-md-3 text-right plabel"><span class="required-indicator">*</span> PO Number:</div>
                            <div class="col-md-9">
                                <input type="text" class="form-control" :ref="'po_number' + key">
                            </div>
                        </div>
                        <div class="row input-wrap">
                            <div class="col-md-3 text-right plabel"><span class="required-indicator">*</span> PO Files (PDF only):</div>
                            <div class="col-md-9"><input type="file" class="form-control" :ref="'po_file' + key" accept="application/pdf" multiple></div>
                        </div>
                        <div class="row input-wrap">
                            <div class="col-md-3 text-right plabel"><span class="required-indicator">*</span> Delivery Date:</div>
                            <div class="col-md-9">
                                <div class="form-control" :ref="'delivery_date' + key">
                                    <date-picker 
                                        value-type="format" 
                                        v-model="car.delivery_date" 
                                        :disabled-date="(date) => date <= disabledBefore" 
                                        :default-value="disabledBefore"
                                        @change="refresh_cars"
                                    >
                                    </date-picker>
                                </div>    
                            </div>
                        </div>
                        <div class="row input-wrap">
                            <div class="col-md-3 text-right plabel"><span class="required-indicator">*</span> Ship To:</div>
                            <div class="col-md-6 no-pr"><input type="text" class="form-control" placeholder="* Address" :ref="'shipping_address' + key" v-model="car.shipping_address"></div>
                            <div class="col-md-3 no-pl">
                                <select class="form-control" :ref="'shipping_country' + key" v-model="car.shipping_country" @change="change_country(car)">
                                    <option value="">* Country</option>
                                    <option v-for="country in countries" :key="country" :value="country">{{ country }}</option>
                                </select>
                            </div>
                        </div>
                        <div class="row input-wrap">
                            <div class="col-md-3"></div>
                            <div class="col-md-3 no-pr"><input type="text" class="form-control" placeholder="* City" :ref="'shipping_city' + key" v-model="car.shipping_city"></div>
                            <div class="col-md-3 no-pr no-pl">
                                <template v-if="!states[car.shipping_country]">
                                    <input key="ss_input" :ref="'shipping_state' + key" type="text" class="form-control" placeholder="* State" v-model="car.shipping_state">
                                </template>
                                <template v-else>
                                    <select key="ss_select" :ref="'shipping_state' + key" class="form-control" v-model="car.shipping_state">
                                        <option value="">* State</option>
                                        <option v-for="state in states[car.shipping_country]" :key="state" :value="state">{{ state }}</option>
                                    </select>
                                </template>
                            </div>
                            <div class="col-md-3 no-pl"><input type="text" class="form-control" placeholder="* Zip" :ref="'shipping_zip' + key" v-model="car.shipping_zip"></div>
                        </div>
                    </div>
                </template>
            </template>
            <template v-else>
                <div class="po-wrap" ref="po_wrap">
                    <div class="row input-wrap">
                        <div class="col-md-3 text-right plabel"><span class="required-indicator">*</span> PO Number:</div>
                        <div class="col-md-9">
                            <input type="text" class="form-control" ref="po_number">
                        </div>
                    </div>
                    <div class="row input-wrap">
                        <div class="col-md-3 text-right plabel"><span class="required-indicator">*</span> PO Files (PDF only):</div>
                        <div class="col-md-9"><input type="file" class="form-control" ref="po_file" accept="application/pdf" multiple></div>
                    </div>
                </div>
            </template>
        </template>

        <template v-if="model.payment_type == 'credit-card'">
            <div class="row input-wrap">
                <div class="col-md-3 text-right plabel"><span class="required-indicator">*</span> Card Type:</div>
                <div class="col-md-9">
                    <select class="form-control" ref="card_type" v-model="model.card_type">
                        <option value="visa">Visa</option>
                        <option value="american-express">American Express</option>
                        <option value="master-card">Master Card</option>
                    </select>
                </div>
            </div>
            <div class="row input-wrap">
                <div class="col-md-3 text-right plabel"><span class="required-indicator">*</span> Card Number:</div>
                <div class="col-md-9">
                    <div class="datepicker-wrap" ref="card_number">
                        <masked-input :mask="card_number_placeholder" class="form-control" v-model="model.card_number" autocomplete="disabled"/>
                    </div>
                </div>
            </div>
            <div class="row input-wrap">
                <div class="col-md-3 text-right plabel"><span class="required-indicator">*</span> CVV:</div>
                <div class="col-md-2">
                    <input type="text" class="form-control" ref="card_cvv" v-model="model.card_cvv">
                </div>
            </div>
            <div class="row input-wrap">
                <div class="col-md-3 text-right plabel"><span class="required-indicator">*</span> Expiry Date:</div>
                <div class="col-md-3 no-pr">
                    <select class="form-control" ref="card_expiry_month" v-model="model.card_expiry_month">
                        <option v-for="month in expiry_months" :key="month.value" :value="month.value">{{ month.name }}</option>
                    </select>
                </div>
                <div class="col-md-3 no-pl">
                    <select class="form-control" ref="card_expiry_year" v-model="model.card_expiry_year">
                        <option v-for="year in expiry_years" :key="year" :value="year">{{ year }}</option>
                    </select>
                </div>
            </div>
            <div class="row input-wrap">
                <div class="col-md-3 text-right plabel"><span class="required-indicator">*</span> Reference Number:</div>
                <div class="col-md-9">
                    <input type="text" class="form-control" ref="customer_reference_no" v-model="model.customer_reference_no">
                </div>
            </div>
            <div class="row input-wrap mt-3">
                <div class="col-md-12">
                    <small>Note: There is 3.4% fee if you choose Credit Card.</small>
                </div>
            </div>
        </template>

        <template v-if="model.payment_type == 'wire-transfer'">
            <div class="row input-wrap">
                <div class="col-md-3 text-right plabel">Instructions:</div>
                <div class="col-md-9">
                    <a href="/api/sp/view/PolicyandProcedure/3. Wire_Transfer_Instructions.pdf?dir=External" target="_blank" class="pdf-link-full"><i class="fa fa-file-pdf-o"></i> Wire Transfer / ACH Instructions</a>
                </div>
            </div>
        </template>

        <template v-if="model.payment_type == 'check'">
           <div class="row input-wrap">
                <div class="col-md-3 text-right plabel">Instructions:</div>
                <div class="col-md-9">
                    <a href="/api/sp/view/PolicyandProcedure/4. Check_Instructions.pdf?dir=External" target="_blank" class="pdf-link-full"><i class="fa fa-file-pdf-o"></i> Check Instructions</a>
                </div>
            </div>
        </template>
    </div>
</template>
<script>
import MaskedInput from 'vue-masked-input'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'

export default {
    components: {
        MaskedInput,
        DatePicker
    },
    data() {
        var lead = 14 * 7,
            lead_sw = 6 * 7;
        let now = new Date
        return {
            lead: lead,
            lead_sw: lead_sw,
            user : {},
            countries: window.countries,
            states: window.states,
            disabledBefore: now.setDate(now.getDate() + lead),
            layout: '',
            expiry_months: [
                { value: '01', name: 'January' },
                { value: '02', name: 'February' },
                { value: '03', name: 'March' },
                { value: '04', name: 'April' },
                { value: '05', name: 'May' },
                { value: '06', name: 'June' },
                { value: '07', name: 'July' },
                { value: '08', name: 'August' },
                { value: '09', name: 'September' },
                { value: '10', name: 'October' },
                { value: '11', name: 'November' },
                { value: '12', name: 'December' }
            ],
            expiry_years: [],
            card_number_placeholder: '4###-####-####-####',
            model: {
                validated: false,
                po_by_car: false,
                payment_type: 'po',
                po: [],
                card_type: 'visa',
                card_number: '',
                card_cvv: '',
                card_expiry_month: '01',
                card_expiry_year: now.getFullYear(),
                customer_reference_no: ''
            }
        }
    },
    props: {
        done: String,
        stype: String,
        cars: Array,
        customer_details: Object,
        shippingDetail: Object
    },
    mounted() {
        let user = localStorage.getItem('user')
        if(!user) {
            this.layout = 'guest'
            this.model.payment_type = 'credit-card'
        }
        this.user = JSON.parse(user);

        let date = new Date();
        var leadt = parseInt(this.user.lead_time) * 7,
            lead = this.stype == 'stock' ? this.lead_sw : leadt;
        this.lead = leadt;
        date.setDate(date.getDate() + lead)
        this.disabledBefore = date

        let now = new Date
        for(let x = 0; x <= 20; x++) {
            this.expiry_years.push(now.getFullYear() + x)
        }
        this.$emit('data', this.model)
    },
    watch: {
        stype: {
            handler: function(data) {
                console.log('isstokk',data);
                if(data) {
                    var date = new Date();
                    var lead = (data == 'stock') ? this.lead_sw : this.lead;
                    date.setDate(date.getDate() + lead);
                    this.disabledBefore = date;
                    this.model.delivery_date = '';
                }
            }
        },
        'model.payment_type'() {
            this.model.po = []
            this.model.card_number = ''
            this.model.card_cvv = ''
            this.model.customer_reference_no = ''

            if(this.model.payment_type == 'credit-card') {
                let now = new Date
                this.model.card_type = 'visa'
                this.model.card_expiry_month = '01'
                this.model.card_expiry_year = now.getFullYear()
            } else {
                this.model.card_type = ''
                this.model.card_expiry_month = ''
                this.model.card_expiry_year = ''
            }
            
            this.$emit('data', this.model)
        },
        'model.card_type'(n) {
            let mask = {
                'visa': '4###-####-####-####',
                'american-express': '3###-######-#####',
                'master-card': '5###-####-####-####'
            }
            this.card_number_placeholder = mask[n]
        },
        'model.po_by_car'(n) {
            if(n) {
                for(let n in this.cars) {
                    for(let key in this.shippingDetail) {
                        this.cars[n][key] = this.shippingDetail[key]
                    }
                }
            }

            this.$emit('po_by_car', n)
        },
        'done'() {
            this.model.po = []
            let errors = []

            if(this.model.payment_type == 'po') {
                if(this.model.po_by_car) {
                    for(let x in this.cars) {
                        if(this.$refs['po_number' + x] != undefined) {
                            let po_number = this.$refs['po_number' + x][0].value
                            let po_file = this.$refs['po_file' + x][0].files

                            if(!po_number) {
                                errors['po_number' + x] = ['Required']
                            }
                            if(!po_file || po_file.length == 0) {
                                errors['po_file' + x] = ['Required']
                            }
                            if(!this.cars[x].delivery_date) {
                                errors['delivery_date' + x] = ['Required']
                            }
                            if(!this.cars[x].shipping_address) {
                                errors['shipping_address' + x] = ['Required']
                            }
                            if(!this.cars[x].shipping_city) {
                                errors['shipping_city' + x] = ['Required']
                            }
                            if(!this.cars[x].shipping_country) {
                                errors['shipping_country' + x] = ['Required']
                            }
                            if(!this.cars[x].shipping_state) {
                                errors['shipping_state' + x] = ['Required']
                            }
                            if(!this.cars[x].shipping_zip) {
                                errors['shipping_zip' + x] = ['Required']
                            }

                            if(po_number && po_file) {
                                if(this.model.po[x] == undefined) {
                                    this.model.po.push({ 
                                        car_num: this.cars[x].car_num,
                                        car_id_number: this.cars[x].car_id_number,
                                        number: po_number,
                                        file: po_file,
                                        delivery_date: this.cars[x].delivery_date,
                                        shipping_address: this.cars[x].shipping_address,
                                        shipping_city: this.cars[x].shipping_city,
                                        shipping_country: this.cars[x].shipping_country,
                                        shipping_state: this.cars[x].shipping_state,
                                        shipping_zip: this.cars[x].shipping_zip
                                    })
                                } else {
                                    this.model.po[x] = { 
                                        car_num: this.cars[x].car_num,
                                        car_id_number: this.cars[x].car_id_number,
                                        number: po_number,
                                        file: po_file,
                                        delivery_date: this.cars[x].delivery_date,
                                        shipping_address: this.cars[x].shipping_address,
                                        shipping_city: this.cars[x].shipping_city,
                                        shipping_country: this.cars[x].shipping_country,
                                        shipping_state: this.cars[x].shipping_state,
                                        shipping_zip: this.cars[x].shipping_zip
                                    }
                                }
                            }
                        }
                    }
                } else {
                    if(this.$refs['po_number'] != undefined) {
                        let po_number = this.$refs['po_number'].value
                        let po_file = this.$refs['po_file'].files

                        if(!po_number) {
                            errors['po_number'] = ['Required']
                        }
                        if(!po_file || po_file.length == 0) {
                            errors['po_file'] = ['Required']
                        }

                        this.model.po = { number: po_number, file: po_file }
                    }
                }
            } else if(this.model.payment_type == 'credit-card') {
                let required = ['card_type', 'card_number', 'card_cvv', 'card_expiry_month', 'card_expiry_year', 'customer_reference_no']
                required.forEach(element => {
                    if(!this.model[element]) {
                        errors[element] = ['Required']
                    }
                })
            }

            if(Object.keys(errors).length > 0) {
                this.model.validated = false
            } else {
                this.model.validated = true
            }

            this.validation_error(errors)
            this.$emit('data', this.model)
        },
        'customer_details'(n) {
            if(Object.keys(n).length > 0) {
                if(n.cc_only == 1) {
                    this.layout = 'guest'
                    this.model.payment_type = 'credit-card'
                }
            }
        }
    },
    methods: {
        change_country(car) {
            let states = this.states[car.shipping_country]
            if(states != undefined) {
                let cur_state = car.shipping_state
                car.shipping_state = ''
                
                for(let key in states) {
                    if(states[key] == cur_state) {
                        car.shipping_state = states[key]
                        break
                    }
                }
            }
            this.refresh_cars()
        },
        refresh_cars() {
            let cars = this.cars
            this.cars = []
            this.cars = cars
        },
        validation_error(errors) {
            Array.from(document.querySelectorAll('#payment-wrap .hasError')).forEach(function(el) { 
                el.classList.remove('hasError');
            })
                            
            for(let el in this.$refs) {
                if(errors[el] !== undefined) {
                    let ref = this.$refs[el]
                    if(Array.isArray(ref)) {
                        ref = ref[0]
                    }
                    ref.classList.add('hasError')
                    if(Object.keys(errors)[0] == el) {
                        ref.focus()
                    }
                }
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.payment-type-row {
    padding: 2px 10px;
}
.input-wrap {
    padding: 2px 10px;
}
.plabel {
    padding-top: 7px;
}
.no-pr {
    padding-right: 2px;
}
.no-pl {
    padding-left: 0;
}
.po-wrap {
    margin-bottom: 1em;
    position: relative;
}
.btnRemovePo {
    border-radius: 50%;
    height: 30px;
    width: 30px;
    padding: 0;
    position: absolute;
    right: 0;
    top: -12px;
    background: #ff6666;
    color: #fff;
}
.btnAddPo {
    margin-right: 12px;
}
.pdf-link-full {
    display: inline-block;
    border: 1px solid blue;
    padding: 0 10px;
    line-height: 30px;
    color: #0000cd;
    font-size: 11px;
    font-weight: normal;
    letter-spacing: 0.1px;
    text-decoration: none;
    &:hover, &:focus {
        color: #0000cd;
        text-decoration: none;
    }
    i {
        background: blue;
        color: #FFF;
        padding: 8px 10px 9px;
        font-size: 14px;
        margin: -6px 6px -6px -10px;
    }
}
@media (max-width: 768px) {
    .payment-type-row {
        padding: 0;
    }
    .input-wrap {
        padding: 0;
    }
    .plabel {
        text-align: left !important;
    }
    .no-pr {
        padding-right: 15px;
    }
    .no-pl {
        padding-left: 15px;
    }
    .col-md-3, .col-md-9 {
        margin-bottom: 2px;
    }
}
</style>